import React from 'react';

import { Link } from 'toolkit/chakra/link';
import { number } from 'ui/home/saba/format';
import Hash from 'ui/home/saba/Hash';
import Icon from 'ui/home/saba/Icon';
import styles from 'ui/home/saba/SabaHome.module.css';

export default function TransactionIdentity({ hash, blockNumber }: { hash: string; blockNumber: number | null }) {
  return (
    <span className={ styles.transactionIdentity }>
      { blockNumber === null ? (
        <span className={ styles.transactionBlock }>—</span>
      ) : (
        <Link className={ styles.transactionBlock } href={ `/block/${ blockNumber }` } title={ `بلاک ${ blockNumber }` }>
          <Icon name="box" size={ 13 }/>
          { number(blockNumber, 0) }
        </Link>
      ) }
      <Hash hash={ hash } href={ `/tx/${ hash }` }/>
    </span>
  );
}
